module.exports = {"name":"muirGlacier","comment":"HF to delay the difficulty bomb","eip":{"url":"https://eips.ethereum.org/EIPS/eip-2384","status":"Last Call"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ethereumjs-common/dist/hardforks/muirGlacier.json
// module id = G3v1
// module chunks = 5